import { render } from "./ModifyLoginPassword.vue?vue&type=template&id=7f4b740e&scoped=true"
import script from "./ModifyLoginPassword.vue?vue&type=script&lang=js"
export * from "./ModifyLoginPassword.vue?vue&type=script&lang=js"

import "./ModifyLoginPassword.vue?vue&type=style&index=0&id=7f4b740e&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4b740e"]])

export default __exports__